module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-square-fill-ff5b00c5.svg";